(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        channelsFn(
            module.exports,
            require('../../enums/timePeriod.js'),
            require('../object.js'),
            require('lodash'),
            require('backbone')
        );
    } else {
        RivalIQ.module('data');

        channelsFn(
            RivalIQ.data,
            RivalIQ.enums.timePeriod,
            RivalIQ.Object,
            window._,
            window.Backbone
        );
    }

    function channelsFn(data, enums, BaseObject, _, Backbone) {

        const TimePeriodDefinition = BaseObject.extend({
            idAttribute: 'id',
            initialize: function (attrs) {
                const me = this;
                me.id = me.cid = attrs.id;
                me.attributes = attrs;
            },

            get: function (property) {
                const me = this;
                return me.attributes[property];
            },

            toJSON: function () {
                const me = this;
                return _.clone(me.attributes);
            },

            validPeriods: function (periodType) {
                const me = this;
                return data.timePeriodDefinitions.forPeriod(periodType, me);
            },

            isCustom: function () {
                const me = this;
                return Boolean(me.attributes.isCustom);
            },

            canEditDates: function () {
                const me = this;
                return Boolean(me.attributes.editable);
            },

            getDates: function (dates, defined) {
                const me = this;
                return me.get('dates')(dates, defined);
            }
        });

        const TimePeriodDefinitions = Backbone.Collection.extend({
            model: TimePeriodDefinition,

            _isModel: function (model) {
                return model instanceof TimePeriodDefinition;
            }
        });

        const types = {};
        data.timePeriodDefinitions = {
            types: types
        };

        types[enums.periodType.MAIN_PERIOD] = new TimePeriodDefinitions(_.values(enums.mainPeriodDefinition));
        types[enums.periodType.COMPARE_PERIOD] = new TimePeriodDefinitions(_.values(enums.comparePeriodDefinition));

        data.timePeriodDefinitions.forPeriod = function (periodType, periodDefinition, sortByAttr) {
            let definitions = data.timePeriodDefinitions.types[periodType].filter(function (def) {
                return periodDefinition.get('validWith')[periodType] & def.id;
            });
            if (sortByAttr) {
                definitions = _.sortBy(definitions, function (definition) {
                    return definition.get(sortByAttr);
                });
            }
            return new TimePeriodDefinitions(definitions);
        };

        data.timePeriodDefinitions.get = function (periodType, id) {
            return data.timePeriodDefinitions.types[periodType].get(id);
        };
    }
})();
